import React from "react";

const FiveStarRating = ({rating, empty = false, ...props}) => {

    let containerClass = 'whitespace-no-wrap rating ' + (props.className || '')

    return (
        <span className={containerClass}>
            {TB.map([1, 2, 3, 4, 5], star => {
                let starClass = "";

                // Disabled/muted if no ratings
                if (!rating || empty) {
                    starClass = 'far fa-star no-rating'
                } else {
                    if (star <= rating) {
                        starClass = 'fas fa-star'
                    } else {
                        if (rating % 1 !== 0 && star <= Math.ceil(rating)) {
                            starClass = 'fas fa-star-half-alt'
                        } else {
                            starClass = 'far fa-star'
                        }
                    }
                }
                return (
                    <i key={`rating-${star}`} className={starClass}/>
                )
            })}
        </span>
    )
}
export default FiveStarRating
